module.exports = __webpack_public_path__ + "static/media/submittedWhiteSmall.f79dea29.png";